import request from '@/utils/request'

// 认证
export const login = data => request.post('/auth/login', data)
export const sendLoginSmsCode = data => request.post('/auth/sms-code', data)
export const loginByPhone = data => request.post('/auth/login-phone', data)
export const sendChangePasswordSms = () => request.post('/auth/change-password/send-sms')
export const changePasswordBySms = data => request.post('/auth/change-password', data)

// 数据看板
export const getDashboard = (params) => request.get('/dashboard', { params })

// 用户管理
export const getUsers = params => request.get('/users', { params })
export const addUser = data => request.post('/users', data)
export const updateUser = (id, data) => request.put(`/users/${id}`, data)
export const resetPassword = (id, data) => request.put(`/users/${id}/reset-password`, data)
export const getUserPermissions = id => request.get(`/users/${id}/permissions`)
export const assignUserPermissions = (id, permissionIds) => request.put(`/users/${id}/permissions`, { permissionIds })
export const getAllUsers = () => request.get('/users/all')
export const userRefreshCache = () => request.post('/users/refreshCache')
export const userRefreshSalesmenCache = () => request.post('/users/refreshSalesmenCache')
export const userRefreshStockUserCache = () => request.post('/users/refreshStockUserCache')
export const getStockUserAll = () => request.get('/users/stockUserAll')


// 角色管理
export const getRoles = params => request.get('/roles', { params })
export const getAllRoles = () => request.get('/roles/all')
export const addRole = data => request.post('/roles', data)
export const updateRole = (id, data) => request.put(`/roles/${id}`, data)
export const deleteRole = id => request.delete(`/roles/${id}`)
export const getRolePermissions = id => request.get(`/roles/${id}/permissions`)
export const assignRolePermissions = (id, permissionIds) => request.put(`/roles/${id}/permissions`, { permissionIds })
export const rolesRefreshCache = () => request.post('/roles/refreshCache')

// 权限管理
export const getPermissions = () => request.get('/permissions')
export const getPermissionsGrouped = () => request.get('/permissions/grouped')
export const getPermissionMenuList = () => request.get('/permissions/menuList')
export const addPermission = data => request.post('/permissions/add',data)
export const updatePermission = data => request.put('/permissions/update',data)
export const deletePermission = id => request.delete(`/permissions/delete/${id}`)

// 商品管理
export const getProducts = params => request.get('/productSpu', { params })
export const getStatusSummary = params => request.get('/productSpu/getStatusSummary', { params })
export const publishProductWithSkus = data => request.post('/productSpu/with-skus', data)
export const getSpuDetails = params => request.get(`/productSpu/getDetails`,{ params })
export const updateProductWithSkus = (id, data) => request.put(`/productSpu/${id}/with-skus`, data)
export const confirmBatchLaunch = data => request.put(`/productSpu/confirmBatchLaunch`, data)
export const confirmBatchDelisted = data => request.put(`/productSpu/confirmBatchDelisted`, data)
export const getProductSkus = productId => request.get(`/productSpu/${productId}/skus`)
export const getProductSkuStocks = productId => request.get(`/productSpu/${productId}/sku-stocks`)
export const getProductSkusPage = params => request.get('/productSpu/skus', { params })
export const publishProduct = id => request.put(`/productSpu/${id}/publish`)
export const deleteProduct = id => request.delete(`/productSpu/${id}`)
export const getDistributorBySpuId = id => request.get(`/productSku/getDistributorBySpuId/${id}`)

// sku相关
export const searchSkuList = params => request.get('/productSku/getSkuCodeList', { params })
export const searchSkuAndStockList = params => request.get('/productSku/getSkuCodeAndStockList', { params })

// 商品分类
export const getCategoryTree = () => request.get('/categories/tree')
export const getCategoryCacheTree = () => request.get('/categories/cacheTree')
export const createCategory = data => request.post('/categories', data)
export const updateCategory = (id, data) => request.put(`/categories/${id}`, data)
export const deleteCategory = id => request.delete(`/categories/${id}`)
export const categoryRefreshCache = id => request.post(`/categories/refreshCache`)


// 商品规格基础选项（颜色/尺码）
export const getProductSpecOptions = params => request.get('/product-spec-options', { params })
export const getProductSpecOptionCaches = params => request.get('/product-spec-options/cacheList', { params })
export const addProductSpecOption = data => request.post('/product-spec-options', data)
export const updateProductSpecOption = (id, data) => request.put(`/product-spec-options/${id}`, data)
export const deleteProductSpecOption = id => request.delete(`/product-spec-options/${id}`)
export const productSpecOptionRefreshCache = params => request.post('/product-spec-options/refreshCache', { params })


// 文件上传
export const uploadImage = data => request.post('/upload/image', data)
export const uploadPdf = data => request.post('/upload/pdf', data)

// 物流公司（快递公司）管理
export const getExpressCompanies = params => request.get('/express-companies', { params })
export const getAllExpressCompanies = () => request.get('/express-companies/all')
export const addExpressCompany = data => request.post('/express-companies', data)
export const updateExpressCompany = (id, data) => request.put(`/express-companies/${id}`, data)
export const deleteExpressCompany = id => request.delete(`/express-companies/${id}`)
export const expressCompanyRefreshCache = id => request.post(`/express-companies/refreshCache`)


// 仓库管理
export const getWarehouses = params => request.get('/warehouses', { params })
export const getAllWarehouses = () => request.get('/warehouses/all')
export const warehousesRefreshCache = () => request.post('/warehouses/refreshCache')
export const addWarehouse = data => request.post('/warehouses', data)
export const updateWarehouse = (id, data) => request.put(`/warehouses/${id}`, data)
export const deleteWarehouse = id => request.delete(`/warehouses/${id}`)
export const getSkuStockWarehouse = params => request.get(`/warehouses/getSkuStockWarehouse`,{ params })

// 省份
export const getAllProvinces = () => request.get('/provinces/all')
export const getProvinces = () => request.get('/provinces')
export const addProvince = data => request.post('/provinces', data)
export const updateProvince = (id, data) => request.put(`/provinces/${id}`, data)
export const deleteProvince = id => request.delete(`/provinces/${id}`)

// 订单管理
export const getOrders = params => request.get('/orders', { params })
export const getOrderStatusSummary = params => request.get('/orders/getStatusSummary', { params })
export const addOrder = data => request.post('/orders', data)
export const updateOrder = (id, data) => request.put(`/orders/${id}`, data)
export const getOrderById = id => request.get(`/orders/${id}`)
export const getOrderItems = id => request.get(`/orders/${id}/items`)
export const updateOrderStatus = data => request.post('/orders/updateOrderStatus', data)
export const updateException = data => request.put('/orders/updateException', data)
export const updateLogisticsInfo = data => request.put('/orders/updateLogisticsInfo', data)
export const getOrderTracking = id => request.get(`/orders/${id}/tracking`)
export const batchOrderShippingFee = data => request.put('/orders/shipping-fee/batch', data)
export const shipOrder = (id, data) => request.put(`/orders/${id}/ship`, data)
export const pickOrderStart = id => request.put(`/orders/${id}/pick-start`)
export const pickOrder = id => request.put(`/orders/${id}/pick`)
export const pickOrderException = (id, data) => request.put(`/orders/${id}/pick-exception`, data)
export const completeOrder = id => request.put(`/orders/${id}/complete`)
export const payOrder = id => request.put(`/orders/${id}/pay`)
export const cancelOrder = (id, data) => request.put(`/orders/${id}/cancel`, data)
export const batchOrderSetStatus = data => request.put('/orders/status/batch', data)
export const updateShippingCost = data => request.put('/orders/updateShippingCost', data)

// 日志
export const getBusinessLogs = params => request.get('/businessOperationLog', { params })

// 通用业务操作日志
export const getBizOperationLogs = params => request.get('/biz-operation-logs', { params })

// 通知（需用户确认）
export const getSysNoticeList1 = params => request.get('/sysNotice/list1', { params })
export const getSysNoticeList2 = () => request.get('/sysNotice/list2')
export const addNotice = data => request.post('/sysNotice/addNotice', data)
export const ackPriceChangeNotices = data => request.post('/sysNotice/ackPriceChangeNotices', data)
export const getTotalUnreadCount = () => request.get('/sysNotice/getTotalUnreadCount')

// 分销商管理
export const getDistributors = params => request.get('/distributors', { params })
export const getAllDistributors = () => request.get('/distributors/all')
export const addDistributor = data => request.post('/distributors', data)
export const updateDistributor = (id, data) => request.put(`/distributors/${id}`, data)
export const deleteDistributor = id => request.delete(`/distributors/${id}`)
export const distributorWalletRecharge = (data) => request.put(`/distributorWallet/recharge`, data)
export const getSalesmen = () => request.get('/users/salesmen')
export const freezeDistributor = (id, data) => request.put(`/distributors/${id}/freeze`, data)
export const unfreezeDistributor = (id, data) => request.put(`/distributors/${id}/unfreeze`, data)
export const getDistributorFreezeLogs = (id, params) => request.get(`/distributors/${id}/freeze-logs`, { params })
export const distributorRefreshCache = () => request.post('/distributors/refreshCache')
export const getDistributorData = (id) => request.get(`/distributors/getDistributorData/${id}`)


// 个人主页
export const getUserInfo = (id) => request.get(`/users/${id}`)
export const transferToCredit = (data) => request.put(`/distributorWallet/transferToCredit`, data)

// 分销子账号管理
export const getSubAccounts = params => request.get('/distributor/sub-accounts', { params })
export const addSubAccount = data => request.post('/distributor/sub-accounts', data)
export const updateSubAccountStatus = (id, data) => request.put(`/distributor/sub-accounts/${id}/updateStatus`, data)

// 分销商申请/审核
export const applyDistributor = data => request.post('/distributor-applies', data)
export const getDistributorApplies = params => request.get('/distributor-applies', { params })
export const approveDistributorApply = (id, data) => request.put(`/distributor-applies/${id}/approve`, data)
export const rejectDistributorApply = (id, data) => request.put(`/distributor-applies/${id}/reject`, data)

//分销商钱包资金流水
export const getDistributorWalletLogs = params => request.get('/distributorWalletLogs', { params })


// 分销商钱包/提现
export const getDistributorWallet = id => request.get(`/distributorWallet/${id}/wallet`)
export const getDistributorCreditSummary = id => request.get(`/distributorWallet/${id}/credit-summary`)
export const getDistributorCreditLogs = params => request.get('/distributor-wallet-logs', { params: { ...(params || {}), walletType: 'CREDIT' } })
export const repayDistributorCredit = (id, data) => request.post(`/distributorWallet/${id}/credit-repay`, data)

// AI扣费字典（可配置扣费单价）
export const getAiFeeDictionary = () => request.get('/ai-fee-dictionary')
export const addAiFeeDictionary = data => request.post('/ai-fee-dictionary', data)
export const updateAiFeeDictionary = (id, data) => request.put(`/ai-fee-dictionary/${id}`, data)
export const deleteAiFeeDictionary = id => request.delete(`/ai-fee-dictionary/${id}`)

// 延期还款
export const applyCreditDelayRequest = data => request.post('/credit-delay-requests', data)
export const getCreditDelayRequests = params => request.get('/credit-delay-requests', { params })
export const approveCreditDelayRequest = id => request.put(`/credit-delay-requests/${id}/approve`)
export const rejectCreditDelayRequest = (id, data) => request.put(`/credit-delay-requests/${id}/reject`, data)

// 分销商提现记记录
export const getWithdraws = params => request.get('/distributorWithdraws', { params })
export const applyWithdraw = data => request.post('/distributorWithdraws', data)
export const approveWithdraw = id => request.put(`/distributorWithdraws/${id}/approve`)
export const transferWithdraw = id => request.put(`/distributorWithdraws/${id}/transfer`)
export const rejectWithdraw = (id, data) => request.put(`/distributorWithdraws/${id}/reject`, data)

// 渠道商务钱包/充值/提现/流水
export const getSalesmanWalletData = () => request.get('/salesman-wallet/getSalesmanWalletData')

export const getSalesmanWallet = (userId) => request.get('/salesman-wallet', { params: userId ? { userId } : {} })
export const getSalesmanWalletLogs = params => request.get('/salesman-wallet-logs', { params })
export const getSalesmanRecharges = params => request.get('/salesman-recharges', { params })
export const approveSalesmanRecharge = id => request.put(`/salesman-recharges/${id}/approve`)
export const rejectSalesmanRecharge = (id, data) => request.put(`/salesman-recharges/${id}/reject`, data)

// 渠道商务提现记录
export const getSalesmanWithdraws = params => request.get('/salesmanWithdraws', { params })
export const applySalesmanWithdraw = data => request.post('/salesmanWithdraws', data)
export const approveSalesmanWithdraw = id => request.put(`/salesmanWithdraws/${id}/approve`)
export const transferSalesmanWithdraw = id => request.put(`/salesmanWithdraws/${id}/transfer`)
export const rejectSalesmanWithdraw = (id, data) => request.put(`/salesmanWithdraws/${id}/reject`, data)

// 等级管理
export const getDistributorLevels = () => request.get('/rebate-levels')
export const getDistributorLevelCaches = () => request.get('/rebate-levels/cacheList')
export const addDistributorLevel = data => request.post('/rebate-levels', data)
export const updateDistributorLevel = (id, data) => request.put(`/rebate-levels/${id}`, data)
export const rebateLevelsRefreshCache = () => request.post('/rebate-levels/refreshCache')


// 锁仓/虚拟库存
export const getMyLockConfigs = () => request.get('/lock-levels/my')
export const getLockConfigsByLevel = level => request.get('/lock-levels', { params: { level } })
export const createLockConfig = data => request.post('/lock-levels', data)
export const updateLockConfig = (id, data) => request.put(`/lock-levels/${id}`, data)
export const replaceLockConfigsByLevel = (level, list) => request.put('/lock-levels/replace', list || [], { params: { level } })
export const getVirtualStockSummary = (productId, distributorId) => request.get('/virtual-stocks/summary', { params: { productId, distributorId } })
export const lockStock = data => request.post('/lock-stocks', data)
export const lockStockBatch = data => request.post('/lock-stocks/batch', data)
export const getMyLockOrders = params => request.get('/lock-stocks/my', { params })

// 生产订单（众筹单）
export const getProductionOrders = params => request.get('/production-orders', { params })
export const getOpenProductionOrders = params => request.get('/production-orders/open', { params })
export const getMyProductionOrders = params => request.get('/production-orders/my', { params })
export const getProductionOrderSubs = id => request.get(`/production-orders/${id}/subs`)
export const placeProductionOrder = data => request.post('/production-orders/place', data)
export const placeProductionOrderBatch = data => request.post('/production-orders/place-batch', data)
export const setProductionOrderDeadline = (id, data) => request.put(`/production-orders/${id}/deadline`, data)
export const startProductionOrder = id => request.put(`/production-orders/${id}/start-produce`)
export const completeProductionOrder = (id, data) => request.put(`/production-orders/${id}/complete`, data)

// 渠道商务等级
export const getSalesmanLevels = () => request.get('/salesman-rebate-levels')
export const getSalesmanLevelCaches = () => request.get('/salesman-rebate-levels/cacheList')
export const addSalesmanLevel = data => request.post('/salesman-rebate-levels', data)
export const updateSalesmanLevel = (id, data) => request.put(`/salesman-rebate-levels/${id}`, data)
export const salesmanRebateLevelRefreshCache = () => request.post(`/salesman-rebate-levels/refreshCache`)


// 分销商充值
export const getRecharges = params => request.get('/recharges', { params })
export const applyRecharge = data => request.post('/recharges', data)
export const approveRecharge = id => request.put(`/recharges/${id}/approve`)
export const rejectRecharge = (id, data) => request.put(`/recharges/${id}/reject`, data)

// 供应商管理
export const getSuppliers = params => request.get('/suppliers', { params })
export const addSupplier = data => request.post('/suppliers', data)
export const updateSupplier = (id, data) => request.put(`/suppliers/${id}`, data)
export const deleteSupplier = id => request.delete(`/suppliers/${id}`)
export const getSupplierWallet = id => request.get(`/suppliers/${id}/wallet`)
export const getSupplierWalletLogs = params => request.get('/supplier-wallet-logs', { params })

// 财务管理
export const getFinanceRecords = params => request.get('/finance', { params })
export const addFinanceRecord = data => request.post('/finance', data)
export const updateFinanceRecord = (id, data) => request.put(`/finance/${id}`, data)
export const getFinanceLogs = params => request.get('/finance/logs', { params })

// 分账管理（基于订单）
export const getFinanceOrderSplitPage = params => request.get('/finance/order-split/page', { params })
export const getFinanceOrderSplitStat = params => request.get('/finance/order-split/stat', { params })

// sku管理
export const getInventory = params => request.get('/productSkuStock', { params })
export const getInventoryBySkuCode = params => request.get('/productSkuStock/by-sku-code', { params })
export const addInventory = data => request.post('/productSkuStock', data)
export const updateInventory = (id, data) => request.put(`/productSkuStock/${id}`, data)

// 库存管理
export const getUserInventory = params => request.get('/inventoryUserStock', { params })
export const getUserInventoryBySkuCode = params => request.get('/inventoryUserStock/by-sku-code', { params })
export const addUserInventory = data => request.post('/inventoryUserStock', data)
export const updateUserInventory = (id, data) => request.put(`/inventoryUserStock/${id}`, data)

// 库存变动记录
export const getInventoryLogs = params => request.get('/inventoryChangeLog/logs', { params })

// 物流管理
export const getLogistics = params => request.get('/logistics', { params })
export const addLogistics = data => request.post('/logistics', data)
export const updateLogistics = (id, data) => request.put(`/logistics/${id}`, data)
